module.exports = __webpack_public_path__ + "static/img/meitanlogo.7c1f810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/meitanlogo.png
// module id = wtUW
// module chunks = 44